import { FrontendLeaderboard } from 'features/Leaderboard'

export default FrontendLeaderboard
